var map = {
	"./Bancontact.png": 55178,
	"./Link1.png": 17773,
	"./affirm.png": 44749,
	"./alipay.png": 42309,
	"./amazonPay.png": 98212,
	"./applePay.png": 55161,
	"./card.png": 69542,
	"./cashAppPay.png": 33240,
	"./googlePay.png": 13700,
	"./klarna.png": 51337,
	"./link.png": 38427,
	"./wechat.png": 70376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11944;